import React, {useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import { CardActions, CardContent } from '@mui/material';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import { useMutation } from "react-query";
import { useNavigate } from 'react-router-dom';
import apiClient from "../../request/http-common";
import { useDispatch } from 'react-redux';
import { setTradings } from '../../request/Analysis/hitorySlice';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import Chip from '@mui/material/Chip';

const DefaultTrader = () => {

    const [error, setErros] = useState('');

    const appMode = useSelector((state) => state.mode.mode);
    const currentPair = useSelector((state) => state.currentPair.currentPair);
    const coinRates = useSelector((state) => state.coins.coinRates);
    const tradingPlans = useSelector((state) => state.plans.tradingPlans);

    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);


    const initwallet = {
        start_time : '',
        duration : '',
        stake : '', 
        stop_loss: '',
        take_profit: '',
    }

    const [walletForm, setwalletForm] = useState(initwallet);
    const onChange = (e) =>
    setwalletForm({ ...walletForm, [e.target.name]: e.target.value });

    

    const [coinDetails, setCoinDetails ] = useState(null);
    const calculate24hrChange = (coin) => {
      let pair = {};
      coinRates.forEach(coinRater => {
        if (coinRater.symbol === coin) {
          pair = coinRater;
        }
      });
    return pair;
    }

    const [amount, setAmount] = useState(0);  
    const navigate = useNavigate();
    const mainBal = useSelector((state) => state.wallet.withdrawableBalance);
    const dispatch = useDispatch();

    const [selectedPlan, setSelectedPlan] = useState('');
    const [source, setSource] = useState('');

    const setPlanDetails = (planId) =>{
      tradingPlans.forEach(plan => {
        if (parseInt(plan.id) === parseInt(planId)) {
          setSelectedPlan(plan);
          setSource(planId);
        }
      });
    }

    const [orderType, setOrderType] = useState('up');

    const { isLoading: isInvesting, mutate: postInvestment } = useMutation(
      async () => {
        return await apiClient.post(`/api/start-trading`, {
          timer_units: source,
          amount: amount, 
          duration: walletForm.duration,
          stop_loss: walletForm.stop_loss,
          take_profit: walletForm.take_profit,
          trading_pair: currentPair,
          order_type: orderType,
          pair: currentPair,
          entry_point: parseFloat(coinDetails.priceUsd).toFixed(6)
        });
      },
      {
        onSuccess: (res) => {
            if (res.data.status === 'success') {
              dispatch(setTradings(res.data.tradings));
              localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
              setTimeout(() => {
                navigate('/trade-history');
              }, 2000);
            }            
        },
        onError: (err) => {
              if (err.response?.data.length) {
                let myerror = err.response?.data || err;         
            setErros(myerror.errors)               
            }else{
                let errorMessage = err.response?.data.message || err ;
                localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
            }
        },
      }
    );

    useEffect(() => {
      setCoinDetails(calculate24hrChange(currentPair))     
    }, []);

  return (
    <div style={{marginTop: '70px'}}>
      <Container>
            <Typography mb={2}  ml={3} mt={4} sx={{ fontWeight: 'bold', fontSize: 20, textTransform: 'uppercase', textAlign: 'center'  }} gutterBottom variant="h6" component="div">
              <Chip icon={<SwapHorizIcon/>} label={`${currentPair}/USDT`} variant="outlined" />
            </Typography>
            {coinDetails !== null && 
            <Grid container  mb={4} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={12} md={8}>
                    <Card px={2}  sx={{borderRadius: '9px'}}>
                        <CardContent sx={{display: 'flex', justifyContent: 'space-between'}}>
                          
                           <Box sx={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left'}}>
                              <Box>                            
                                <Typography variant="h6" gutterBottom sx={{fontSize: {md: '24px', xs: '18px'} , color: `${parseFloat(coinDetails.changePercent24Hr) >= 0 ? '#198c41': '#f31348'}`}}>
                                  {(parseFloat(coinDetails.priceUsd).toFixed(6))}
                                </Typography>
                                <Typography variant="subtitle2" gutterBottom sx={{fontSize: {md: '18px', xs: '14px'}}} >
                                  {formatPrice(parseFloat(coinDetails.priceUsd).toFixed(6))}
                                </Typography>
                              </Box>
                            </Box>  
                            <Box sx={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left'}}>
                              <Box>
                                <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                  24h Change ({currentPair})
                                </Typography>
                                <Typography sx={{fontSize: {md: '9px', xs: '8px'}, color: `${parseFloat(coinDetails.changePercent24Hr) >= 0 ? '#198c41': '#f31348'}`}} variant="subtitle2" gutterBottom>
                                {parseFloat(coinDetails.changePercent24Hr).toFixed(6)}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                  24h Change (USDT)
                                </Typography>
                                <Typography sx={{fontSize: {md: '9px', xs: '8px'}, color: `${parseFloat(calculate24hrChange('USDT').changePercent24Hr) >= 0 ? '#198c41': '#f31348'}`}} variant="subtitle2" gutterBottom>
                                {/* {parseFloat(coinDetails.changePercent24Hr).toFixed(6)} */}
                                {parseFloat(calculate24hrChange('USDT').changePercent24Hr).toFixed(6)}
                                </Typography>
                              </Box>
                            </Box> 
                            <Box sx={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left'}}>
                              <Box>
                              <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                24h Volume ({currentPair})
                              </Typography>
                              <Typography variant="subtitle2" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'}}}>
                              {parseFloat(coinDetails.volumeUsd24Hr).toFixed(4)}
                              </Typography>
                              </Box>

                              <Box>
                              <Typography variant="caption" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'} }}>
                                24h Volume (USDT)
                              </Typography>
                              <Typography variant="subtitle2" gutterBottom sx={{fontSize: {md: '9px', xs: '8px'}}}>
                              {parseFloat(calculate24hrChange('USDT').volumeUsd24Hr).toFixed(4)}
                              </Typography>
                              </Box>
                            </Box>   
                                                     
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={8}>
                    <Card px={0}  sx={{borderRadius: '9px', height: '100%'}}>
                        <CardContent justifyContent="center" sx={{padding: 0, marginBottom: '0px'}}>

                          {/* <TradingChart pair={`${currentPair}USDT`}/> */}

                        <AdvancedRealTimeChart
                                symbol= {`BINANCE:${currentPair}USDT`}
                                interval= "1"
                                timezone= "Etc/UTC"
                                theme= {appMode}
                                locale= "en"
                                style='1'
                                hide_top_toolbar= {true}
                                enable_publishing= {false}
                                save_image={false}
                                backgroundColor={appMode === 'dark' ? '#121212' : '#ffffff'}
                                hide_side_toolbar={true}
                                allow_symbol_change={false}
                                container_id= "898980"
                                isTransparent = {true}
                                range='YTD'
                                height={400}
                                width="100%"
                              >
                               </AdvancedRealTimeChart>
                          {appMode === 'dark'? 
                          <Box sx={{height: '20px', backgroundColor: 'background.paper', transform: 'translate(0px, -25px)', position: 'relative', zIndex: 1}}>
                          
                          </Box>
                          :
                          <Box sx={{height: '20px', backgroundColor: 'white', transform: 'translate(0px, -25px)', position: 'relative', zIndex: 1}}>
                          
                          </Box>
                          }
                          <Avatar sx={{display: 'absolute', zIndex: 10, transform: 'translate(10px, -170px)'}} alt="Payment icon" src="https://res.cloudinary.com/dg8pxsdme/image/upload/v1705500463/trustutilsdefi500_zqpbh7.png" />
                          
                          </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} sx={{display: {md: 'block', xs: 'none'}}} md={4}>
                    <Card px={2}  sx={{borderRadius: '9px', height: '100%'}}>
                      
                        <CardContent justifyContent="center">
                          
                        <Box mt={4} sx={{display: 'flex', justifyContent: 'space-between'}}>
                       
                      <FormControl fullWidth={true} sx={{mt: 1, minWidth: 50 }}>
                          <InputLabel htmlFor="time">Timer Units</InputLabel>
                          {(error !== '' && error.time) ?
                          <Select
                          error
                          onChange={(e) => setPlanDetails(e.target.value)}
                          labelId="time"
                          id="time"
                          name="time"
                          label={`Timer Units`}
                          helperText={error.time}
                          >
                          <MenuItem selected value=''>
                          Select Option
                          </MenuItem> 
                          {tradingPlans.length > 0 && tradingPlans.map(plan =>(
                            <MenuItem selected value={plan.id}
                            >
                            {plan.duration}
                            </MenuItem>
                          ))}
                      </Select>
                        :
                        <Select
                            onChange={(e) => setPlanDetails(e.target.value)}
                            labelId="time"
                            name="time"
                            id="time"
                            label={`Timer Units`}
                            >
                            <MenuItem selected value=''>
                            Seconds
                            </MenuItem> 

                            {tradingPlans.length > 0 && tradingPlans.map(plan =>(
                            <MenuItem selected value={plan.id}>
                            {plan.duration}
                            </MenuItem>
                          ))}
                        </Select>
                        }
                        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        {error !== '' && error.time}
                        </Typography>
                    </FormControl>

                    <FormControl  fullWidth={true} sx={{marginLeft: '5px',  mt: 1, minWidth: 50 }}>
                        <InputLabel htmlFor="duration">Duration</InputLabel>
                        {(error !== '' && error.duration) ?

                        <OutlinedInput
                        onChange={onChange}
                        error
                        id="duration"
                        type={'text'}
                        name="duration"
                        label="Duration"
                        helperText={error.duration}
                        />
                        :
                        <OutlinedInput
                        onChange={onChange}
                        id="duration"
                        type={'text'}
                        name="duration"
                        label="Duration"
                        />
                        }
                        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        {error !== '' && error.duration}
                        </Typography>
                      </FormControl>
                    </Box>

                        {(selectedPlan !== '') &&
                        <Alert severity="success">Gain: {selectedPlan.min_range}% ~ {selectedPlan.max_range}%
                        </Alert>
                        }

                        <FormControl  fullWidth={true} sx={{ mt: 1, mb: 1, minWidth: 50 }}>
                        <InputLabel htmlFor="amount">Stake (USDT)</InputLabel>
                        <OutlinedInput
                          onChange={(e)=>setAmount(e.target.value)}
                          id="amount"
                          type={'number'}
                          label="Stake (USDT)"
                        />
                      </FormControl>
                        {selectedPlan !== '' &&
                        <Alert severity="info">
                          <Typography>
                          Min Stake: {formatPrice(selectedPlan.min_amount)}
                          </Typography>
                          <Typography>
                          Max Stake: {formatPrice(selectedPlan.max_amount)} 
                          </Typography>                         
                        </Alert>
                        }

                    
                    

                  <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                    <FormControl  fullWidth={true} sx={{ mt: 1, minWidth: 50 }}>
                      <InputLabel htmlFor="take_profit">Take Profit (optional)</InputLabel>
                      {(error !== '' && error.stake) ?

                      <OutlinedInput
                      onChange={onChange}
                      error
                      id="take_profit"
                      type={'text'}
                      name="take_profit"
                      label="Take Profit (optional)"
                      helperText={error.take_profit}
                      />
                      :
                      <OutlinedInput
                      onChange={onChange}
                      id="take_profit"
                      type={'text'}
                      name="take_profit"
                      label="Take Profit (optional)"
                      />
                      }
                      <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                      {error !== '' && error.take_profit}
                      </Typography>
                  </FormControl>  

                  <FormControl fullWidth={true} sx={{marginLeft: '5px', mt: 1, minWidth: 50 }}>
                      <InputLabel htmlFor="stop_loss">Stop Loss (optional)</InputLabel>
                      {(error !== '' && error.stake) ?

                      <OutlinedInput
                      onChange={onChange}
                      error
                      id="stop_loss"
                      type={'text'}
                      name="stop_loss"
                      label="Stop Loss (optional)"
                      helperText={error.stop_loss}
                      />
                      :
                      <OutlinedInput
                      onChange={onChange}
                      id="stop_loss"
                      type={'text'}
                      name="stop_loss"
                      label="Stop Loss (optional)"
                      />
                      }
                      <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                      {error !== '' && error.stop_loss}
                      </Typography>
                  </FormControl> 
                  </Box> 

                      {(selectedPlan !== '' && amount !== 0) &&
                        <Alert severity="success">Potential Profit:  {formatPrice((selectedPlan.min_range/100) * amount)} ~ {formatPrice((selectedPlan.max_range/100) * amount)} 
                        </Alert>
                        }
                        </CardContent>

                        <CardActions sx={{justifyContent: 'space-between'}}>
                            <Button onClick={() => {
                              setOrderType('up');
                              setTimeout(() => {
                                postInvestment();
                              }, 1000);
                              
                            }} fullWidth={true} variant="contained" color='success' startIcon={<ArrowUpwardIcon />}>
                                 {isInvesting && orderType === 'up'? 'confirming...' : 'Up'}
                            </Button>

                            <Button onClick={() => {
                              setOrderType('down');
                              setTimeout(() => {
                                postInvestment();
                              }, 1000);
                            }} fullWidth={true} variant="contained" color='secondary' startIcon={<ArrowDownwardIcon />}>
                                {isInvesting && orderType === 'down' ? 'confirming...' : 'Down'}
                            </Button>

                        </CardActions>

                    </Card>
                </Grid>
            
            </Grid>
          }
        </Container>
    </div>
  )
}

export default DefaultTrader
